import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import StatusWorkflowDangerIcon from '@atlaskit/icon-lab/core/status-workflow-danger';
import StatusWorkflowInProgressIcon from '@atlaskit/icon-lab/core/status-workflow-in-progress';
import StatusWorkflowInactiveIcon from '@atlaskit/icon-lab/core/status-workflow-inactive';
import StatusWorkflowIncompleteIcon from '@atlaskit/icon-lab/core/status-workflow-incomplete';
import StatusWorkflowPausedIcon from '@atlaskit/icon-lab/core/status-workflow-paused';
import StatusWorkflowReturnedIcon from '@atlaskit/icon-lab/core/status-workflow-returned';
import StatusWorkflowScheduledIcon from '@atlaskit/icon-lab/core/status-workflow-scheduled';
import StatusWorkflowStoppedIcon from '@atlaskit/icon-lab/core/status-workflow-stopped';
import { Text } from '@atlaskit/primitives';
import Tooltip, { PositionType } from '@atlaskit/tooltip';

import defaultStatuses from './statuses';
import * as styles from './styled';

const icons = {
  PARSING: 'building',
  PENDING: 'default',
  READY: 'building',
  IN_PROGRESS: 'building',
  PULLING_IMAGES: 'building',
  UPLOADING_ARTIFACTS: 'building',
  UPLOADING_CACHES: 'building',
  UPLOADING_METRICS: 'building',
  UPLOADING_VARIABLES: 'building',
  PARSING_TEST_RESULTS: 'building',
  DOWNLOADING_ARTIFACTS: 'building',
  DOWNLOADING_CACHES: 'building',
  DOWNLOADING_TEST_METADATA: 'building',
  COMPLETING_LOGS: 'building',
  CLONING: 'building',
  RUNNING: 'building',
  PAUSED: 'paused',
  HALTED: 'halted',
  QUEUED: 'waiting',
  ERROR: 'failed',
  SYSTEM_ERROR: 'failed',
  USER_ERROR: 'failed',
  FAILED: 'failed',
  FAILED_REDEPLOY: 'failed_redeploy',
  REDEPLOY: 'redeploy',
  RERUN: 'rerun',
  SUCCESSFUL: 'success',
  STOPPED: 'stopped',
  SKIPPED: 'stopped',
  NOT_RUN: 'default',
  UNDEPLOYED: 'success',
  unknown: 'default',
  fail: 'failed',
  complete: 'success',
  default: 'default',
  ACTION_REQUIRED: 'halted',
};

export type StatusIconProps = {
  status: string;
  statuses?: any;
  icon?: any;
  className?: string;
  isLabelHidden?: boolean;
  tooltipContent?: any;
  tooltipPosition?: PositionType;
};

type Statuses = {
  [key: string]: any;
};

const statusIcons: Statuses = {
  success: CheckCircleIcon,
  failed: StatusWorkflowDangerIcon,
  stopped: StatusWorkflowStoppedIcon,
  paused: StatusWorkflowInactiveIcon,
  building: StatusWorkflowInProgressIcon,
  halted: StatusWorkflowPausedIcon,
  waiting: StatusWorkflowScheduledIcon,
  redeploy: StatusWorkflowReturnedIcon,
  failed_redeploy: StatusWorkflowReturnedIcon,
  rerun: StatusWorkflowReturnedIcon,
  unknown: StatusWorkflowIncompleteIcon,
  default: StatusWorkflowIncompleteIcon,
};

const StatusIcon = ({
  status,
  statuses = defaultStatuses,
  icon = icons,
  className = '',
  isLabelHidden,
  tooltipContent,
  tooltipPosition = 'right',
}: StatusIconProps) => {
  if (!status) return null;

  const state = icon[status] || 'unknown';
  const statusText = statuses[status] || 'Unknown';
  const Icon = statusIcons[state];

  const StatusIconWrapper = (
    <styles.Wrapper
      data-state={state}
      data-testid="pipeline-status"
      className={className}
    >
      <Icon label={statusText} />
      {!isLabelHidden ? (
        <Text as="span" weight="bold" color="inherit">
          {statusText}
        </Text>
      ) : null}
    </styles.Wrapper>
  );

  if (!tooltipContent) {
    return StatusIconWrapper;
  }

  return (
    <Tooltip content={tooltipContent} position={tooltipPosition} tag="span">
      {StatusIconWrapper}
    </Tooltip>
  );
};

// eslint-disable-next-line import/no-default-export
export default StatusIcon;
